import { ProfessionIcon } from './profession-icon';

export const IconConsultant = () => (
  <ProfessionIcon bg="#E8EAF6">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"
        stroke="#3F51B5"
        strokeWidth="1.8"
      />
      <path
        d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"
        stroke="#3F51B5"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <line
        x1="12"
        y1="12"
        x2="12"
        y2="16"
        stroke="#3F51B5"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <line
        x1="10"
        y1="14"
        x2="14"
        y2="14"
        stroke="#3F51B5"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
